/** Preserve provider-signed fields; only the backend can verify their signature. */
export function getOAuthQuery(search: string): string | undefined {
  const pageParameters = new URLSearchParams(search);
  if (pageParameters.has("oauth_query")) {
    return pageParameters.getAll("oauth_query").length === 1
      ? pageParameters.get("oauth_query")!
      : "";
  }
  if (!pageParameters.has("sig")) return undefined;

  // Better Auth 1.7.5 redirects with a flat query and a signed field manifest.
  const signedParameterNames = new Set(pageParameters.getAll("ba_param"));
  const signedParameters = new URLSearchParams();
  pageParameters.forEach((parameterValue, parameterName) => {
    if (parameterName === "sig" || parameterName === "ba_param" || signedParameterNames.has(parameterName)) {
      signedParameters.append(parameterName, parameterValue);
    }
  });
  return signedParameters.toString();
}

/** Accept redirect targets only from an API response, never from page parameters. */
export function getOAuthResponseUrl(redirectUrl: unknown): string {
  if (typeof redirectUrl !== "string" || !redirectUrl.trim()) {
    throw new Error("The authorization server did not return a redirect URL. Restart the connection from your app.");
  }
  const parsedRedirectUrl = new URL(redirectUrl);
  if (parsedRedirectUrl.protocol !== "https:" && parsedRedirectUrl.protocol !== "http:") {
    throw new Error("The authorization server returned an unsupported redirect URL.");
  }
  return parsedRedirectUrl.href;
}

export function navigateToOAuthResponseUrl(redirectUrl: unknown): void {
  window.location.assign(getOAuthResponseUrl(redirectUrl));
}

export function isLoopbackOAuthUrl(redirectUrl: string | null): boolean {
  if (!redirectUrl) return false;
  try {
    const parsedRedirectUrl = new URL(getOAuthResponseUrl(redirectUrl));
    return ["127.0.0.1", "localhost", "[::1]"].includes(parsedRedirectUrl.hostname);
  } catch {
    return false;
  }
}
